import { api } from '@/api/common/instances';

const state = {
  systems: [],
  system: {},
};

const getters = {
  getSystemsByStack: state => stack => {
    return state.systems.filter(system => system.stackType === stack);
  },
  getSystemById: state => id => {
    return state.systems.find(system => id === system.id);
  },
  getSystemsByStackAndIds: state => (stack, ids) => {
    return state.systems.filter(system => system.stackType === stack && ids.includes(system.id));
  },
  getDescendantsById: state => id => {
    const system = state.systems.find(system => system.id === id);
    if (system !== undefined) {
      return system.stackType === 'ABAP' ? system.abapInstances : system.javaInstances.reduce((descendants, descendant) => descendants.concat(descendant.nodes), []);
    }
    return [];
  },
  getJavaInstances: state => systemId => {
    const system = state.systems.find(system => system.id === systemId);
    return system !== undefined ? system.javaInstances : [];
  },
  getNodes: state => (systemId, instanceId) => {
    const system = state.systems.find(system => system.id === systemId);
    const instances = system !== undefined ? system.javaInstances : [];
    const instance = instances.find(instance => instance.id === instanceId);
    return instance ? instance.nodes : [];
  },
};

const mutations = {
  setSystems(state, systems) {
    state.systems = systems;
  },
  setSystem(state, system) {
    state.system = system;
  },
};

const actions = {
  async fetchSystems({ commit, state }) {
    if (!state.systems.length) {
      // BEGIN::Modified.by.KWShin.2023.10.26. ROLE_USER 사용자는 /preference URL에 대한 접근 권한이 없어서 문제가 됨.
      // const { data } = await api.get('/preference/systems');
      const { data } = await api.get('/prefer/systems');
      //FINISH::Modified.by.KWShin.2023.10.26.
      commit('setSystems', data);
    }
  },
  setSystems({ commit }, systems) {
    commit('setSystems', systems);
  },
  setSystem({ commit, state }, id) {
    commit('setSystem', state.systems.find(system => system.id === id) || {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
